export default __webpack_public_path__ + "static/media/kitchen3-after3-1920w.a10ed309.png";